import { Container, Image, TextArea, Form, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterStep1DataProjectNeed, setLetterStep1DataAddedValueOfProgrammApproch, setLetterStep1DataAdditional, setLetterStep1DataObjectiveContribution, setLetterStep1DataPartnershipRelevance, setLetterContactPoint} from "../../redux/projectSlice"

const Step1DetailRejection = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleChangeTextArea = (e, data) => {
        if (data.className.split(' ').find(class_ => class_ === 'project-need')) {
            dispatch(setLetterStep1DataProjectNeed(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'contribution')) {
            dispatch(setLetterStep1DataObjectiveContribution(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'added-value-project')) {
            dispatch(setLetterStep1DataAddedValueOfProgrammApproch(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'partnership-relevance')) {
            dispatch(setLetterStep1DataPartnershipRelevance(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'additional')) {
            dispatch(setLetterStep1DataAdditional(data.value));
        }
    }

    const handleSelectChange = (e, data) => {
        dispatch(setLetterContactPoint(data.value));
    }

    // const renderContactPoint = () => {
    //     const lp = projectState.leadPartner
    //     let codePays = lp.addresses.filter(address => address.type === 'Organization')[0].countryCode
    //     if (codePays === 'BE') {
    //         codePays = lp.addresses.filter(address => address.type === 'Organization')[0].nutsRegion2Code.substring(0, 3)
    //         //console.log(codePays)
    //     }
        
    //     const contactPoints = projectState.letterContactPoints.filter(contactPoint => contactPoint.codePays === codePays)
    //     if (contactPoints.length === 0) {
    //         //Sconsole.warn('contact point not found !!');
    //         return(<Message negative><Message.Header>We didn't find the contact point for this area: ({codePays})</Message.Header></Message>)
    //     } else {
    //         return (
    //             <span>
    //                 {contactPoints.map(ct => (
    //                     <span>{ct.contact} (<a href={"mailto:"+ct.email}>{ct.email}</a>), </span> 
    //                 ))}
    //                 contact point for {contactPoints[0].pays}
    //             </span>
    //         )
    //     }
    // }


    
    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {contact.title} {contact.firstName} {contact.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {projectState.letter?.commission?.step1LetterDate}
                    </p>
                </Container>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        const selectedContactPoint = projectState.contactPoints.filter(contactPoint => contactPoint.value === letter?.contactPoint)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                <p>We are grateful for your efforts and the interest you have shown in our cooperation Programme by submitting the step 1 application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span>.</p>
                <p>However, we regret to inform you that the Interreg NWE Monitoring Committee decided not to select your application during its meeting on {letter?.commission?.step1Date} in {letter?.commission?.step1Location}. The Monitoring Committee assessment outcomes conclusions are annexed to this letter and aim to provide better insight on this decision.</p>
                <p>We also kindly ask you to inform your partners.</p>
                {/* <p>If you have <span className="text-accent">questions</span> and would like more information regarding this decision, please contact {renderContactPoint()}, who will handle your questions on behalf of the Programme.</p> */}
                <p>If you have <span className="text-accent">questions</span> and would like more information regarding this decision, please contact <Select placeholder="Select contact point" defaultValue={selectedContactPoint} options={projectState.contactPoints} className="invisible-print" onChange={handleSelectChange} /> {!letter?.contactPoint ? undefined : <span className="invisible-screen">{letter?.contactPoint[0]} <span className="text-accent">({letter?.contactPoint[1]})</span></span>}, who will handle your questions on behalf of the Programme.</p>
                {/* <p>If you would like more information, please contact {renderContactPoint} the Interreg NWE Contact Point for {pays}.</p> */}
                {/* <p>Should you wish to make a <span className="text-accent">formal complaint</span> against this decision, you have the right to do so. Please note that such complaints must be filed in English and in writing (via post to Interreg North-West Europe Les Arcuriales - 45, rue de Tournai, 6/D - F-59000 Lille - France or email to <a href="mailto:nwe@nweurope.eu">nwe@nweurope.eu</a>) to the Joint Secretariat within five weeks of the present notification and addressed to the Programme Director. Please also note that complaints must be well-grounded, that there is no specific complaint form for this call and that only you as project’s lead applicant can file a complaint. Potential complaints from partners must be filed through the lead applicant.</p> */}
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the Programme Manual.</p>
                {/* <p>Information about the complaint procedure regarding this decision can be found in Chapter 7 of the Programme Manual.</p> */}
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski</p>
                <p>Programme Director</p>
            </Container>
        )
    }

    // const renderProjectPoints = (data) => {
    //     const listePoints = data.split(' \n').map(point => point.replace('\n-', '').replace(' /^-+/'))//
    //     return (
    //         <List bulleted>
    //             {listePoints.map(point => {
    //                 return <List.Item>{point}</List.Item>
    //             })}
    //         </List>
    //     )
    // }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Monitoring Committee conclusions</h3>
                <div className="prevent-page-break little-margin">
                    {/* {letter?.step1Data?.projectNeed ? <h4>Project need and justification</h4> : <h4 className="invisible-print">Project need and justification</h4>} */}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-need" onChange={handleChangeTextArea} value={letter?.step1Data?.projectNeed}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.projectNeed}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.objectiveContribution ? <h4>Contribution to Programme objectives</h4> : <h4 className="invisible-print">Contribution to Programme objectives</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print contribution" onChange={handleChangeTextArea} value={letter?.step1Data?.objectiveContribution}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.objectiveContribution}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.addedValueOfProgrammApproch ? <h4>Added value of project approach</h4> : <h4 className="invisible-print">Added value of project approach</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print added-value-project" onChange={handleChangeTextArea} value={letter?.step1Data?.addedValueOfProgrammApproch}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.addedValueOfProgrammApproch}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.partnershipRelevance ? <h4>Partnership relevance</h4> : <h4 className="invisible-print">Partnership relevance</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print partnership-relevance" onChange={handleChangeTextArea} value={letter?.step1Data?.partnershipRelevance}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.partnershipRelevance}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step1Data?.additional ? <h4>Other</h4> : <h4 className="invisible-print">Other</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print additional" onChange={handleChangeTextArea} value={letter?.step1Data?.additional}>  </TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step1Data?.additional}</p>
                </div>
            </Container>
        )
    }
    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                                {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default Step1DetailRejection;